import { DEFAULT_ANIMATE_DURATION } from '@apeiron/temp'
import { LoadingButtonProps } from '@mui/lab/LoadingButton'
import { styled } from '@mui/material'
import ApeironLoadingButton from '@src/components/share/apeiron/ApeironLoadingButton'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type ConfirmButtonProps = Omit<LoadingButtonProps, 'children'>

const StyledLoadingButton = styled(ApeironLoadingButton)`
  width: 150px;
  height: 45px;
  color: #ffffff;
  background-color: #005bd7;
  text-transform: none;
  font-size: 16px;
  line-height: 18px;
  transition: color ${DEFAULT_ANIMATE_DURATION}ms,
    background-color ${DEFAULT_ANIMATE_DURATION}ms;

  &:hover {
    background-color: #3682eb;
  }

  &:disabled,
  &.disabled {
    background-color: #535556;
    color: #777979;
  }
`

const ApeironConfirmButton: React.FC<ConfirmButtonProps> = props => {
  const { t } = useTranslation()

  const { loading } = props

  return (
    <StyledLoadingButton {...props}>
      {!loading && t('common.confirm')}
    </StyledLoadingButton>
  )
}

export default ApeironConfirmButton
